/**
 * Compact TCG silhouette icons for the NextDropBanner (Phase 12).
 * Each icon is rendered at ~28x28 with a soft per-icon drop-shadow glow.
 * Pure inline SVG — no external libraries — so bundle stays lean.
 */

export function PokeballIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        filter:
          "drop-shadow(0 0 6px rgba(239, 68, 68, 0.6)) drop-shadow(0 0 3px rgba(239, 68, 68, 0.6))",
      }}
    >
      {/* Bottom half — dark */}
      <path
        d="M4 16a12 12 0 0 0 24 0H4z"
        fill="#18181b"
      />
      {/* Top half — deep red */}
      <path
        d="M4 16a12 12 0 0 1 24 0H4z"
        fill="#ef4444"
      />
      {/* Center band */}
      <rect x="4" y="14.5" width="24" height="3" fill="#18181b" />
      {/* Outer stroke */}
      <circle
        cx="16"
        cy="16"
        r="12"
        fill="none"
        stroke="#0a0a0a"
        strokeWidth="1"
      />
      {/* Center release button */}
      <circle cx="16" cy="16" r="3.2" fill="#18181b" />
      <circle cx="16" cy="16" r="2" fill="#e5e5e5" />
    </svg>
  );
}

export function YugiohCardIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        filter:
          "drop-shadow(0 0 6px rgba(139, 92, 246, 0.55)) drop-shadow(0 0 3px rgba(139, 92, 246, 0.55))",
      }}
    >
      {/* Card body — tall portrait rounded rect, deep purple */}
      <rect
        x="9"
        y="3"
        width="14"
        height="26"
        rx="2"
        fill="#8b5cf6"
      />
      {/* Inner frame — slightly lighter purple to add depth */}
      <rect
        x="11"
        y="5"
        width="10"
        height="22"
        rx="1"
        fill="none"
        stroke="#a78bfa"
        strokeWidth="0.75"
      />
      {/* Abstract diamond/gem in the middle */}
      <path
        d="M16 12 L20 16 L16 20 L12 16 Z"
        fill="#c4b5fd"
      />
      <path
        d="M16 12 L20 16 L16 20 L12 16 Z"
        fill="none"
        stroke="#e9d5ff"
        strokeWidth="0.6"
      />
    </svg>
  );
}

export function DragonBallStarIcon({ className = "" }) {
  return (
    <svg
      viewBox="0 0 32 32"
      className={className}
      aria-hidden="true"
      focusable="false"
      style={{
        filter:
          "drop-shadow(0 0 6px rgba(251, 191, 36, 0.6)) drop-shadow(0 0 3px rgba(251, 191, 36, 0.6))",
      }}
    >
      {/* Solid 5-point star, gold */}
      <path
        d="M16 3 L19.6 12.2 L29.4 12.6 L21.6 18.9 L24.4 28.4 L16 22.9 L7.6 28.4 L10.4 18.9 L2.6 12.6 L12.4 12.2 Z"
        fill="#fbbf24"
      />
      {/* Inner highlight to give a slight shine */}
      <path
        d="M16 6.5 L18.6 13 L25.6 13.3 L20.1 17.7 L22 24.4 L16 20.5 L10 24.4 L11.9 17.7 L6.4 13.3 L13.4 13 Z"
        fill="none"
        stroke="#fde68a"
        strokeWidth="0.6"
        opacity="0.8"
      />
    </svg>
  );
}
